import React, { forwardRef } from 'react'

import cn from 'classnames'

import styles from './IconButton.module.scss'
import { IconButtonProps } from './types'
import BaseButton from '../BaseButton'
import ghostButtonStyles from '../GhostButton/GhostButton.module.scss'
import primaryButtonStyles from '../PrimaryButton/PrimaryButton.module.scss'
import secondaryButtonStyles from '../SecondaryButton/SecondaryButton.module.scss'

const IconButton: React.FC<IconButtonProps> = forwardRef(
  ({ className, children, variant = 'ghost', isLoading, isDisabled, isReverse, ...props }, ref) => {
    const stylesToUse =
      variant === 'primary'
        ? primaryButtonStyles
        : variant === 'secondary'
        ? secondaryButtonStyles
        : ghostButtonStyles

    return (
      <BaseButton
        className={cn(
          styles.iconButton,
          stylesToUse.iconButton,
          variant === 'primary' && primaryButtonStyles.primaryButton,
          variant === 'secondary' && secondaryButtonStyles.secondaryButton,
          variant === 'ghost' && ghostButtonStyles.ghostButton,
          (isDisabled || isLoading) && stylesToUse[`${variant}Button_disabled`],
          isLoading && stylesToUse[`${variant}Button_isLoading`],
          isReverse && stylesToUse[`${variant}Button_reverse`],
          className,
        )}
        isLoading={isLoading}
        isDisabled={isDisabled || isLoading}
        isIconOnly
        styles={styles}
        ref={ref}
        {...props}
      >
        {children}
      </BaseButton>
    )
  },
)

export default IconButton
